import bp from '@bbl-digital/snorre/lib/globals/styles/breakpoints'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Scrollable = styled.div(
  ({ maxHeight = 55 }: { maxHeight?: number }) => css`
    max-height: ${maxHeight}vh;
    overflow: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;

    @media screen and (max-width: ${bp.medium}) {
      max-height: ${maxHeight - 5}vh;
    }

    @media screen and (max-width: ${bp.small}) {
      max-height: ${maxHeight - 15}vh;
    }
  `
)
